export default __webpack_public_path__ + "static/media/tiktok.c0a18872.png";